<template>
  <section id="start-screen">
    <div class="front">

      <section class="d-flex flex-grow-1 flex-column w-100 h-100 items-center ">

        <div class="d-flex flex-grow-1 container-fluid flex-wrap  flex-md-row-reverse align-items-md-center justify-content-md-around
        justify-content-sm-center align-items-sm-center align-content-sm-center flex-md-row">

          <div class="d-flex  col-lg-4 col-md-5 col-sm-8">
            <div class=" d-flex align-items-center">
              <img height=40 src="../assets/logo/w-virtex@3x.png" alt="">
            </div>
          </div>

          <div class="d-flex mt-md-0 mt-sm-4 flex-column col-lg-3 col-md-4 col-sm-8">
            <btn-start-screen @handleClick="actionBtnImClient" text="Sou cliente" class="w-100"></btn-start-screen>
            <btn-start-screen @handleClick="actionBtnImNotClient" text="Não sou cliente" class="w-100 mt-sm-4 mt-md-4 mt-4"></btn-start-screen>
          </div>
        </div>
        <transition name="slide"
                    enter-active-class="animated slideInUp"
                    leave-active-class="animated slideOutDown">
          <redirect-botton-bar
            @handleCancel="hideBar"
            @handleTimeEnd="actionBtnImClient"
            v-if="showBar"/>
        </transition>
      </section>
    </div>
    <div class="back bg-primary">
      <img src="../assets/background/bg_x_neon.png" alt="">
    </div>
  </section>
</template>

<script>
import BtnStartScreen from "../components/BtnStartScreen";
import RedirectBottonBar from "../components/RedirectBottonBar";

import isClientVirtex from "../scripts/isClientVirtex";

import { CONFIG_PAGE, CITY_SELECT } from "../consts/routes";

export default {
  name: "Start",
  components: { RedirectBottonBar, BtnStartScreen },
  data() {
    return { showBar: false };
  },
  created() {
    let isClient = isClientVirtex();

    isClient.then(bool => {
      this.showBar = bool;
    });

    isClient.catch(() => {
      this.showBar = false;
    });
  },
  methods: {
    hideBar() {
      this.showBar = false;
    },
    actionBtnImClient() {
      this.$store.commit("setUserClient", true);
      this.$router.push(CONFIG_PAGE);
    },
    actionBtnImNotClient() {
      this.$store.commit("setUserClient", false);
      this.$router.push(CITY_SELECT);
    }
  }
};
</script>

<style scoped lang="scss">
#start-screen {
  height: 100%;
  min-height: 100%;
  width: 100%;
  position: relative;
}

.back {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.front {
  background: radial-gradient(
    ellipse at center,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.55) 82%,
    rgba(0, 0, 0, 0.75) 100%
  );
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  // background-color: rgba(255, 128, 230, 0.49);
  position: absolute;
  z-index: 2;
}

.progress {
  // width: 40px;
  // height: 40px;
}
</style>
